/* eslint-disable no-unused-vars */
import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { queryClient } from '@hc/utils';
import { httpRequest } from '@hc/utils/axios';
import { toast } from 'react-hot-toast';
import { create } from 'zustand';

export const useSpeciality = create((set, get) => ({
  specialityData: [],
  loading: null,
  error: null,
  getSpecialityData: async () => {
    try {
      set({ loading: true });
      // For preventing duplicate request, we're using react-query

      const { data } = await queryClient.fetchQuery({
        queryKey: ['speciality'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/speciality/getAll`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });
      const specialityDataCopy = [];

      if (Array.isArray(data) && data?.length > 0) {
        data.map((val) => {
          specialityDataCopy.push({
            value: val?.id ?? '',
            label: val?.speciality ?? '',
          });
        });
      }
      return set((state) => ({
        loading: false,
        specialityData: specialityDataCopy,
      }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.response?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
